import { useNavigate, useParams } from "react-router-dom";
import Cupones from "../../page/cupones/Cupones";
import { useContext, useEffect, useState } from "react";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import { authContext } from "../../../../context/auth/AuthContext";
import Cupon from "../../page/cupones/Cupon";
import {
  crearArrayFechas,
  existsEvento,
  obtenerFechasExtremas,
} from "../../../utils/CuponUtils";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const CuponController = () => {
  const navigate = useNavigate();
  const { user } = useContext(authContext);
  const { data } = user;
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [fechas, setFechas] = useState({
    fecha_inicio: null,
    fecha_fin: null,
    dias: [
      "lunes",
      "martes",
      "miercoles",
      "jueves",
      "viernes",
      "sabado",
      "domingo",
    ],
  });
  const dias = [
    { value: "lunes", name: "LU" },
    { value: "martes", name: "MA" },
    { value: "miercoles", name: "MI" },
    { value: "jueves", name: "JU" },
    { value: "viernes", name: "VI" },
    { value: "sabado", name: "SA" },
    { value: "domingo", name: "DO" },
  ];

  const [modalEventos, setModalEventos] = useState(false);
  const [eventos, setEventos] = useState([]);
  const [salas, setSalas] = useState([]);
  const [search, setSearch] = useState("");
  const [cupon, setCupon] = useState({
    id: null,
    nombre: "",
    descuento: "",
    codigo: "",
    status: "",
    fechas_funciones: [],
    fecha_expiracion: "",
    fecha_habilitacion: "",
    tipo_aplicacion: "",
    limite: "",
    search: "",
    eventos: [],
    visible: 1,
  });
  let controller;

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "guardar":
        {
          let formData = new FormData();
          formData.append("nombre", cupon.nombre);
          formData.append("codigo", cupon.codigo);
          formData.append("descuento", cupon.descuento);
          formData.append("limite", cupon.limite);
          formData.append("fecha_habilitacion", cupon.fecha_habilitacion);
          formData.append("fecha_expiracion", cupon.fecha_expiracion);
          formData.append("tipo_aplicacion", cupon.tipo_aplicacion);
          formData.append("visible", cupon.visible);
          formData.append(
            "fechas_funciones",
            JSON.stringify(cupon.fechas_funciones)
          );

          if (cupon.tipo_aplicacion == "eventos") {
            cupon.eventos.map((c, index) => {
              formData.append("eventos[" + index + "][id]", c.id);
            });
          }

          if (cupon.tipo_aplicacion == "salas") {
            cupon.salas.map((c, index) => {
              formData.append("salas[" + index + "][id]", c.id);
            });
          }

          const response = await RestPrivateAntesala({
            url: "/cupones",
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {
            Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
            return navigate(`/dashboard/cupones/${response.data.data.id}`);
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
      case "aplicar":
        {
          let formData = new FormData();
          formData.append("_method", "PUT");
          formData.append("nombre", cupon.nombre);
          formData.append("codigo", cupon.codigo);
          formData.append("descuento", cupon.descuento);
          formData.append("limite", cupon.limite);
          formData.append("fecha_habilitacion", cupon.fecha_habilitacion);
          formData.append("fecha_expiracion", cupon.fecha_expiracion);
          formData.append("tipo_aplicacion", cupon.tipo_aplicacion);
          formData.append("visible", cupon.visible);
          formData.append(
            "fechas_funciones",
            JSON.stringify(cupon.fechas_funciones)
          );

          if (cupon.tipo_aplicacion == "eventos") {
            cupon.eventos.map((c, index) => {
              formData.append("eventos[" + index + "][id]", c.id);
            });
          }

          if (cupon.tipo_aplicacion == "salas") {
            cupon.salas.map((c, index) => {
              formData.append("salas[" + index + "][id]", c.id);
            });
          }

          const response = await RestPrivateAntesala({
            url: `/cupones/${cupon.id}`,
            formData: formData,
            method: "POST",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {
            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
      case "añadir-sala":
        {
          let salas = cupon.salas ?? [];
          salas.push(value);

          setCupon({
            ...cupon,
            salas: salas,
          });

          setSalas([]);
        }
        break;
      case "quitar-sala":
        {
          let salas = cupon.salas;
          delete salas[value];
          salas = salas.filter((f) => f != null);

          setCupon({
            ...cupon,
            salas: salas,
          });

          setSalas([]);
        }
        break;
      case "ver-eventos":
        {
          setModalEventos(true);
        }
        break;
      case "añadir-evento":
        {
          let eventos = cupon.eventos ?? [];
          eventos.push(value);

          setCupon({
            ...cupon,
            eventos: eventos,
          });

          setEventos([]);
        }
        break;
      case "quitar-evento":
        {
          let eventos = cupon.eventos;
          delete eventos[value];
          eventos = eventos.filter((f) => f != null);

          setCupon({
            ...cupon,
            eventos: eventos,
          });

          setEventos([]);
        }
        break;
      case "quitar-fecha":
        {
          let fechas = cupon.fechas_funciones;
          delete fechas[value];
          fechas = fechas.filter((f) => f != null);

          setCupon({
            ...cupon,
            fechas_funciones: fechas,
          });
        }
        break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      case "search-sala":
        {
          if (controller) controller.abort();

          controller = new AbortController();
          const signal = AbortController.signal;

          let params = {
            search: e.target.value,
          };

          setSearch(e.target.value);
          if (e.target.value.length == 0) {
            return setSalas([]);
          }
          return fetch(
            setSalas,
            params,
            "https://test.antesala.com.ar/backend/public/api/salas",
            signal
          );
        }
        break;
      case "search":
        {
          if (controller) controller.abort();

          controller = new AbortController();
          const signal = AbortController.signal;

          let params = {
            per_page: 50,
            ["filter[nombre]"]: e.target.value,
            status: 1,
          };

          setSearch(e.target.value);
          return fetch(setEventos, params, "/eventos", signal);
        }
        break;
      case "nombre":
      case "codigo":
      case "descuento":
      case "limite":
      case "fecha_habilitacion":
      case "fecha_expiracion":
      case "tipo_aplicacion":
      case "visible":
        {
          setCupon({
            ...cupon,
            [e.target.name]: e.target.value,
          });
        }
        break;
      case "fecha_inicio":
        {
          const { fechaAnterior, fechaSiguiente } = obtenerFechasExtremas(
            cupon.fechas_funciones
          );

          let fecha_fin = fechas.fecha_inicio ?? fechaSiguiente;

          const fechasArray = crearArrayFechas(
            e.target.value + " 00:00:00",
            fecha_fin + " 00:00:00"
          );

          setFechas({
            ...fechas,
            fecha_inicio: e.target.value,
          });

          setCupon({
            ...cupon,
            fechas_funciones: fechasArray,
          });
        }
        break;
      case "fecha_fin":
        {
          const { fechaAnterior, fechaSiguiente } = obtenerFechasExtremas(
            cupon.fechas_funciones
          );

          let fecha_inicio = fechas.fecha_inicio ?? fechaAnterior;

          const fechasArray = crearArrayFechas(
            fecha_inicio + " 00:00:00",
            e.target.value + " 00:00:00"
          );

          console.log(fechasArray);

          setFechas({
            ...fechas,
            fecha_fin: e.target.value,
          });

          setCupon({
            ...cupon,
            fechas_funciones: fechasArray,
          });
        }
        break;
    }
  };

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (id) {
       fetch(setCupon, {}, `/cupones/${id}`);
    }
  }, [id]);

  return (
    <Cupon
      eventos={existsEvento(eventos?.data ?? [], cupon.eventos ?? [])}
      search={search}
      data={cupon}
      setData={setCupon}
      onChange={onChange}
      onClick={onClick}
      navigate={navigate}
      user={data}
      modalEventos={modalEventos}
      setModalEventos={setModalEventos}
      dias={dias}
      fechas={fechas}
      setFechas={setFechas}
      salas={existsEvento(salas ?? [], cupon.salas ?? [])}
    />
  );
};

export default CuponController;
